import { BLACK } from '@config/theme/colors'
import { SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

type IconProps = {
	color?: string
	IconElement: OverridableComponent<SvgIconTypeMap>
	onClick?: () => void
	size?: string
}

/**
 * Icon
 * @param color
 * @param IconElement
 * @param onClick
 * @param size
 * @constructor
 */
const Icon = (
	{
		color = BLACK,
		IconElement,
		onClick,
		size = '24px'
	}: IconProps
) => {
	return (
		<IconElement
			sx={{
				color: color,
				cursor: !!onClick ? 'pointer' : 'inherit',
				height: size,
				width: size
			}}
			onClick={onClick}
		/>
	)
}

export default Icon
